module.exports = __webpack_public_path__ + "img/cover26.7f84cd90.png";